/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { InstitutionModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ContentManagementConfigurationClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ContentManagementConfiguration
   * @name ContentManagementConfigurationGet
   * @summary Gets content management data.
   * @request GET:/contentManagementConfiguration
   */
  contentManagementConfigurationGet = (params: RequestParams = {}) =>
    this.http.request<InstitutionModelDto, any>({
      path: `/contentManagementConfiguration`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ContentManagementConfiguration
   * @name ContentManagementConfigurationPost
   * @summary Save content management data.
   * @request POST:/contentManagementConfiguration
   */
  contentManagementConfigurationPost = (
    data: InstitutionModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InstitutionModelDto, any>({
      path: `/contentManagementConfiguration`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
